// useProductionSelectionSelectors.ts
import { useAppDispatch, useAppSelector } from '@app';
//~ Import the selectors from your slice file
import {
    selectIsProductionSelected,
    selectSelectedProduction,
    selectSelectedProductionActiveStatus,
    selectSelectedProductionAvatar,
    selectSelectedProductionHasAvatar,
    selectSelectedProductionId,
    selectSelectedProductionName,
    setProduction,
} from '../slices/productionsSlice';
import { Production } from '../types';

//~ You can also define individual hooks for each selector here

export const useIsProductionSelected = () => {
    return useAppSelector(selectIsProductionSelected);
};

export const useSelectedProduction = () => {
    return useAppSelector(selectSelectedProduction);
};

export const useSelectedProductionId = () => {
    return useAppSelector(selectSelectedProductionId);
};

export const useSelectedProductionName = () => {
    return useAppSelector(selectSelectedProductionName);
};

export const useSelectedProductionActiveStatus = () => {
    return useAppSelector(selectSelectedProductionActiveStatus);
};

export const useSelectedProductionAvatar = () => {
    return useAppSelector(selectSelectedProductionAvatar);
};

export const useSelectedProductionHasAvatar = () => {
    return useAppSelector(selectSelectedProductionHasAvatar);
};

/**
 * Custom hook to access selectors for the productionSelection slice.
 *
 * @returns An object containing selector functions bound to useSelector.
 */
export const useSelectedProductionSelectors = () => {
    //~ Define selector functions for relevant properties here

    const isProductionSelected = useIsProductionSelected();
    const selectedProduction = useSelectedProduction();

    const selectedProductionId = useSelectedProductionId();
    const selectedProductionName = useSelectedProductionName();
    const selectedProductionActiveStatus = useSelectedProductionActiveStatus();
    const selectedProductionAvatar = useSelectedProductionAvatar();
    const selectedProductionHasAvatar = useSelectedProductionHasAvatar();

    return {
        //~ Return all the defined selector values here

        isProductionSelected,
        selectedProduction,

        selectedProductionId,
        selectedProductionName,
        selectedProductionActiveStatus,
        selectedProductionAvatar,
        selectedProductionHasAvatar,
    };
};

export const useSelectProduction = () => {
    const dispatch = useAppDispatch();
    const selectProduction = (production: Production) => {
        dispatch(setProduction(production));
    };

    return { selectProduction };
};
